import { ROLE_OPTIONS } from "./personaRoles";

function RolePicker({ value, onChange }) {
  return (
    <div className="mb-4 rounded-xl border border-rp-border bg-rp-bg p-3" data-testid="chatbot-role-picker">
      <div className="text-[10px] uppercase tracking-wider text-rp-textFaint mb-2 font-mono">
        Your primary role &mdash; we&apos;ll match the best mentor
      </div>
      <div className="flex flex-wrap gap-1.5">
        {ROLE_OPTIONS.map((r) => {
          const isActive = value === r.id;
          return (
            <button
              key={r.id}
              type="button"
              onClick={() => onChange(isActive ? null : r.id)}
              className={`text-[11px] px-2 py-1 rounded-full border transition-colors ${
                isActive
                  ? "border-emerald-400/60 bg-emerald-500/15 text-emerald-300"
                  : "border-rp-border bg-rp-surface text-rp-textDim hover:border-rp-textFaint hover:text-rp-text"
              }`}
              data-testid={`chatbot-role-${r.id}`}
              aria-pressed={isActive}
            >
              <span className="mr-1">{r.icon}</span>
              {r.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function ChatbotPicker({ personas, recommended, role, onRoleChange, onPick }) {
  return (
    <div className="flex-1 overflow-y-auto p-4" data-testid="chatbot-personas">
      <RolePicker value={role} onChange={onRoleChange} />

      <p className="text-xs text-rp-textDim mb-3">
        Choose the mentor whose expertise fits your question. You can switch any time.
      </p>
      <div className="space-y-3">
        {personas.map((p) => {
          const isRec = recommended === p.id;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onPick(p.id)}
              className={`w-full text-left rounded-xl border p-3 transition-all hover:scale-[1.02] ${
                isRec ? "border-emerald-400/50 bg-emerald-900/10" : "border-rp-border bg-rp-bg hover:border-rp-textFaint"
              }`}
              data-testid={`chatbot-persona-${p.id}`}
            >
              <div className="flex items-start gap-3">
                <div
                  className="h-10 w-10 rounded-full flex items-center justify-center text-white font-bold text-sm shrink-0"
                  style={{ backgroundColor: p.color }}
                >
                  {p.name[0]}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="font-semibold text-rp-text text-sm">{p.name}</div>
                    {isRec && (
                      <span className="text-[9px] uppercase tracking-wide text-emerald-300 bg-emerald-500/15 px-1.5 py-0.5 rounded" data-testid={`chatbot-persona-recommended-${p.id}`}>
                        Recommended
                      </span>
                    )}
                  </div>
                  <div className="text-[11px] text-rp-textDim">{p.role}</div>
                  <div className="text-[11px] text-rp-textFaint mt-1">{p.tagline}</div>
                </div>
              </div>
            </button>
          );
        })}
        {personas.length === 0 && (
          <div className="text-sm text-rp-textFaint text-center py-8">
            Loading mentors…
          </div>
        )}
      </div>
    </div>
  );
}
